import PropTypes from 'prop-types'

import './styles.scss'
import { RemoteAttachment } from '../attachments'

import { Preview } from './previewer'

export default function Document (doc) {
  if (doc.id) {

    return (
      <RemoteAttachment
        attributes={{
          style: {
            height: 'calc(100vh - 150px)',
            width: '100%',
            paddingLeft: 0,
            paddingRight: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'block',
            overflowY: 'auto',
            overflowX: 'auto',
            ...(doc.style || {})
          }
        }}
        document={{
          mime: doc.mime,
          id: doc.id,
          title: doc.fileName
        }}
      />)
  }
  return (
    <Preview
      base64={doc.data}
      type={doc.mime}
      style={doc.style}
    />
  )
}

Document.propTypes = {
  data: PropTypes.string,
  mime: PropTypes.string.isRequired,
  id: PropTypes.string,
  fileName: PropTypes.string,
  style: PropTypes.instanceOf(Object)
}
